import Entity, { IEntity } from './Entity';

export enum BOUNDARY_TYPE {
  PHYSICAL = 'PHYSICAL',
  VIRTUAL = 'VIRTUAL',
}

export interface IBoundary extends IEntity {
  type: BOUNDARY_TYPE;
  toJSON: () => object;
}

abstract class Boundary extends Entity implements IBoundary {
  type: BOUNDARY_TYPE;

  constructor(type: BOUNDARY_TYPE) {
    super();
    this.type = type;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      type: this.type, 
    };
  }
}

export default Boundary;
